/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecureScore {
    getFixupPrototypeFunction() { return SecureScore.fixupPrototype; }

    static newInstance(model: Partial<SecureScore>): SecureScore {
        let obj = Object.assign(new SecureScore(), model);
        SecureScore.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecureScore>): SecureScore {
        if (!model) return null;
        return SecureScore.newInstance(<SecureScore> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecureScore) {
        if (!obj) return;

        models.SecureScore.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecureScore): boolean {
        Object.setPrototypeOf(obj, SecureScore.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.max === undefined) {
            this.max = 0;
        }
        if (this.current === undefined) {
            this.current = 0;
        }
        if (this.percentage === undefined) {
            this.percentage = 0;
        }
    }

    /**
     * SecureScore max for the tenant
     */
    max: number;

    /**
     * SecureScore current for the tenant
     */
    current: number;

    /**
     * SecureScore percentage for the tenant
     */
    percentage: number;

}
